import React from 'react';

const ActivityMetaFieldsNote = () => {
  return (
    <p className='note'>
      This activity is now BAT managed. Changes in Shopify will no longer be
      reflected here.
    </p>
  );
};

export default ActivityMetaFieldsNote;
